import styles from './ContractsMobilePriceFilter.module.scss';

interface ContractsMobilePriceFilterProps {
  fromValue?: number;
  toValue?: number;
  onChange: (fromValue?: number, toValue?: number) => void;
}

export const ContractsMobilePriceFilter: React.FC<ContractsMobilePriceFilterProps> = ({
  fromValue,
  toValue,
  onChange,
}) => {
  const handleFromChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value ? parseInt(e.target.value, 10) : undefined;
    onChange(value, toValue);
  };

  const handleToChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value ? parseInt(e.target.value, 10) : undefined;
    onChange(fromValue, value);
  };

  return (
    <div className={styles.priceInputs}>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>От</label>
        <div className={styles.inputWrapper}>
          <input
            type='number'
            className={styles.priceInput}
            placeholder='0'
            min='0'
            value={fromValue || ''}
            onChange={handleFromChange}
          />
        </div>
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>До</label>
        <div className={styles.inputWrapper}>
          <input
            type='number'
            className={styles.priceInput}
            placeholder='1 000 000'
            min='0'
            value={toValue || ''}
            onChange={handleToChange}
          />
        </div>
      </div>
    </div>
  );
};
